export const ADMINFEATURE_KEYS = {
  organizationsKey: 'organizations',
  licensesKey: 'licenses',
  invoicesKey: 'invoices',
  quotesKey: 'quotes',
  infrastructureKey: 'infrastructure',
  dbBackupsKey: 'db backups',
  apiConfigKey: 'api config',
  bankAccountsKey: 'bank accounts',
  wellSeekerAdminKey: 'well seeker admin',
  dbTasksKey: 'db tasks',
  vendorsKey: 'vendors',
  wellListKey: 'well list',
}
